module.exports = __webpack_public_path__ + "static/media/instagram.9049200e.svg";